var _defs, _g, _path, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _text, _g2, _path2, _circle4, _circle5, _circle6, _path3, _circle7, _path4, _path5, _path6, _circle8, _path7, _path8, _ellipse, _ellipse2, _path9, _line, _line2, _g3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerSupportIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "02d45862-41ba-4c70-8782-54d8e5b108cc",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 900.1,
    height: 696.67,
    viewBox: "0 0 900.1 696.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fa4a4f63-ffbe-4a50-a004-4e8ae15cd2d3",
    x1: 583.82,
    y1: 763.13,
    x2: 583.82,
    y2: 246.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e26e1273-ae5e-4f1a-b841-a4248e9532de",
    x1: 584.38,
    y1: 798.34,
    x2: 584.38,
    y2: 714.29,
    xlinkHref: "#fa4a4f63-ffbe-4a50-a004-4e8ae15cd2d3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "54428808-f3ba-4b0a-98a1-6e23268491ee",
    x1: 760.68,
    y1: 248.69,
    x2: 760.68,
    y2: 0,
    xlinkHref: "#fa4a4f63-ffbe-4a50-a004-4e8ae15cd2d3"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "active support") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M971.12,763.13H196.52v-501a15.8,15.8,0,0,1,15.8-15.8h743a15.8,15.8,0,0,1,15.8,15.8Z",
    transform: "translate(-149.95 -101.66)",
    fill: "url(#fa4a4f63-ffbe-4a50-a004-4e8ae15cd2d3)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73,153.77H794.69a15.8,15.8,0,0,1,15.8,15.8V661.47a0,0,0,0,1,0,0H57.24a0,0,0,0,1,0,0V169.58A15.8,15.8,0,0,1,73,153.77Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.49,
    y: 183.31,
    width: 704.75,
    height: 462.25,
    fill: "#f5f5f5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 84.19,
    y: 205.75,
    width: 701.76,
    height: 415.88,
    fill: "#e0e0e0",
    opacity: 0.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84.19,
    y: 183.65,
    width: 701.76,
    height: 22.1,
    fill: "#f5f5f5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.24,
    cy: 194.37,
    r: 5.36,
    fill: "#ff5252"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.97,
    cy: 194.37,
    r: 5.36,
    fill: "#ff0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.71,
    cy: 194.37,
    r: 5.36,
    fill: "#69f0ae"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: -149.95,
    y: -101.66
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M992.79,796.35c-43.12,3.27-783.62,2-809.49,0C149.38,780,150,716.56,150,716.56l339.6-2.27,1.14,19.31H636.06l5.68-17h376.34S1025.56,774.76,992.79,796.35Z",
    transform: "translate(-149.95 -101.66)",
    fill: "url(#e26e1273-ae5e-4f1a-b841-a4248e9532de)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.57,721.67h-369a11.33,11.33,0,0,1-8.6,18.74H494.09a11.33,11.33,0,0,1-8.6-18.74H155.06S154.49,776.76,188,791c25.55,1.7,757,2.84,799.59,0C1020,772.21,1012.57,721.67,1012.57,721.67Z",
    transform: "translate(-149.95 -101.66)",
    fill: "#f5f5f5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.78,
    cy: 631.94,
    r: 4.54,
    fill: "#e0e0e0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.41,
    cy: 631.94,
    r: 4.54,
    fill: "#e0e0e0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.03,
    cy: 631.94,
    r: 4.54,
    fill: "#e0e0e0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M419.88,375.85h32.19a139.5,139.5,0,0,1,139.5,139.5V616.76a0,0,0,0,1,0,0H280.38a0,0,0,0,1,0,0V515.35A139.5,139.5,0,0,1,419.88,375.85Z",
    fill: "#6415ff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.28,
    cy: 179.39,
    r: 142.22,
    fill: "#333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M415.34,334.43h41.13a29,29,0,0,1,29,29v28.26a44.34,44.34,0,0,1-44.34,44.34H430.64a44.34,44.34,0,0,1-44.34-44.34V363.47a29,29,0,0,1,29-29Z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M386.3,331.53h99.22a0,0,0,0,1,0,0v57.3a44.34,44.34,0,0,1-44.34,44.34H430.64a44.34,44.34,0,0,1-44.34-44.34v-57.3A0,0,0,0,1,386.3,331.53Z",
    fill: "#fdb797"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M536.43,447.5a142.8,142.8,0,0,0,99.22.27V435.59H536.43Z",
    transform: "translate(-149.95 -101.66)",
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 436.28,
    cy: 210.26,
    r: 142.22,
    fill: "#fdb797"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M450.26,261.58H721.46S698.31,152.07,595.78,159,450.26,261.58,450.26,261.58Z",
    transform: "translate(-149.95 -101.66)",
    opacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M450.26,257.9H721.46S698.31,148.39,595.78,155.37,450.26,257.9,450.26,257.9Z",
    transform: "translate(-149.95 -101.66)",
    fill: "#333"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 297,
    cy: 204.2,
    rx: 13.23,
    ry: 24.81,
    fill: "#fdb797"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 574.82,
    cy: 204.2,
    rx: 13.23,
    ry: 24.81,
    fill: "#fdb797"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M471.31,185.34c3.25-10.62,9.16-20.77,18.28-27.1,6.93-4.81,15.22-7.12,23.17-9.94a177.08,177.08,0,0,0,33.68-16.11c12.06-7.43,23.39-16.38,36.67-21.29,22.85-8.45,48.3-3.88,71.89,2.18,5.81,1.49,11.69,3.11,16.81,6.25,5.93,3.63,10.48,9.09,14.92,14.44l37.44,45.16c3.43,4.13,6.88,8.31,9.3,13.11a45.09,45.09,0,0,1,4.26,14.79c1,8.28.22,17.06-4,24.27-6.33,10.81-19.38,16.24-31.89,16.74s-24.79-3.13-36.81-6.65c-38.76-11.35-78-21.93-118.2-26.64a333.41,333.41,0,0,0-60.15-1.95c-6.3.41-14.62,3.3-18.45-3.12C464.92,203.91,469.6,190.92,471.31,185.34Z",
    transform: "translate(-149.95 -101.66)",
    fill: "#333"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 341.3,
    y1: 506.34,
    x2: 341.3,
    y2: 616.76,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    opacity: 0.05
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 533.14,
    y1: 506.34,
    x2: 533.14,
    y2: 616.76,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    opacity: 0.05
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "900.1 198.47 721.64 198.47 661.41 248.69 661.41 198.47 621.26 198.47 621.26 0 900.1 0 900.1 198.47",
    fill: "url(#54428808-f3ba-4b0a-98a1-6e23268491ee)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 625.04,
    y: 2.36,
    width: 271.28,
    height: 189.79,
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 655.59,
    y: 30.26,
    width: 214.95,
    height: 5.64,
    fill: "#e0e0e0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 655.59,
    y: 55.66,
    width: 147.78,
    height: 5.64,
    fill: "#e0e0e0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 655.59,
    y: 81.05,
    width: 177.34,
    height: 5.64,
    fill: "#e0e0e0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 655.59,
    y: 106.45,
    width: 142.41,
    height: 5.64,
    fill: "#6415ff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 655.59,
    y: 131.84,
    width: 214.95,
    height: 5.64,
    fill: "#6415ff"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 655.59,
    y: 157.24,
    width: 214.95,
    height: 5.64,
    fill: "#e0e0e0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "671.45 188.46 671.45 238.66 726.66 183.44 671.45 188.46",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSupportIllustration);
export default __webpack_public_path__ + "static/media/customer-support-illustration.7164659e338b9013dc196213c60c8ad2.svg";
export { ForwardRef as ReactComponent };